import IconButtonComponent from '../../Basic/IconButton/IconButton.mjs';
import styled from 'styled-components';

const StyledSearchHeaderClearButton = styled(IconButtonComponent) `
  margin-right: 0.75rem;
  border-radius: 0 8px 8px 0;
  border-left: none;

  svg {
    margin-right: 2px;
    margin-top: 1px;
  }
`;
const StyledSearchHeaderForm = styled.form `
  display: flex;
  justify-content: space-between;
  width: 100%;
  border: 1px solid ${props => props.theme.colors.darkGray};
  border-radius: 8px;
  background-color: ${props => props.theme.colors.backgroundColor};
  transition: all ${props => props.theme.animation.duration.quick2}
    ${props => props.theme.animation.easing.productive.standard};
  box-shadow: 0 0 0 0 ${props => props.theme.colors.darkGray}20;

  @media (pointer: fine) {
    &:hover {
      border-bottom: 1px solid ${props => props.theme.colors.darkGray};
      box-shadow: 0 2px 8px ${props => props.theme.colors.darkGray}30;
    }
  }

  &:focus-within {
    border-color: ${props => props.theme.colors.mist};
    box-shadow: 0 0 0 2px ${props => props.theme.colors.mist}40,
      0 0 12px ${props => props.theme.colors.mist}50, 0 0 20px ${props => props.theme.colors.mist}30;
  }
`;
const StyledSearchHeaderField = styled.input `
  border: none;
  border-right: none;
  background: transparent;
  background-color: transparent;
  color: ${props => props.theme.colors.textColor};
  font-size: ${props => props.theme.typography.headings.h3.fontSize};
  font-weight: ${props => props.theme.typography.fontWeight.medium};
  width: 100%;
  padding: 1rem 3.5rem 1rem 1rem;
  box-sizing: border-box;
  border-radius: 8px 0 0 8px;

  &::placeholder {
    color: ${props => props.theme.colors.mutedTextColor};
  }

  &:focus {
    outline: none;
    background-color: transparent;
    border: none;
    border-right: none;

    &::placeholder {
      color: transparent;
    }
  }

  /* Prevent browser autofill from changing background color */
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px ${props => props.theme.colors.backgroundColor} inset !important;
    -webkit-text-fill-color: ${props => props.theme.colors.textColor} !important;
    background-color: transparent !important;
    background: transparent !important;
    border-radius: 8px 0 0 8px;
    border: none !important;
    border-right: none !important;
  }

  /* Firefox autofill prevention */
  &:-moz-autofill {
    background-color: transparent !important;
    background: transparent !important;
    border-radius: 8px 0 0 8px;
    border: none !important;
    border-right: none !important;
  }

  @media screen and (max-width: ${props => props.theme.breakpoints.md}) {
    padding: 0.875rem 3rem 0.875rem 0.875rem;
  }
`;

export { StyledSearchHeaderClearButton, StyledSearchHeaderField, StyledSearchHeaderForm };
//# sourceMappingURL=SearchHeader.styles.mjs.map
